module.exports = __webpack_public_path__ + "media/images/country_flags/fj-073a68604ae430ac22ac039a66f1bd10.png";